import React, { Suspense } from 'react';
import { Outlet } from 'react-router-dom';
import { I18nProvider } from '../_metronic/i18n/i18nProvider';
import { LayoutProvider, LayoutSplashScreen } from '../_metronic/layout/core';
import { MasterInit } from '../_metronic/layout/MasterInit';
import AnalyticsTracker from './analytics/AnalyticsTracker';
import { AuthInit } from './modules/auth';

export const MyContext = React.createContext(null);

declare global {
  interface Window {
    gtag: any;
  }
}

function AppContent() {
  return (
    <AuthInit>
      <>
        <Outlet />
        <AnalyticsTracker />
        <MasterInit />
      </>
    </AuthInit>
  );
}

const App = () => {
  return (
    <Suspense fallback={<LayoutSplashScreen />}>
      <I18nProvider>
        <LayoutProvider>
          <AppContent />
        </LayoutProvider>
      </I18nProvider>
    </Suspense>
  );
};

export { App };